<template>
    <vx-card no-shadow :title="$t('social_links')">
        <div class="vx-col w-full">
            <div class="mb-2" v-for="(item, index) in links" :key="index">
                <div class="flex mb-2">
                    <div class="lg:flex w-full">
                        <div class="w-full">
                            <!-- Список типов достижений -->
                            
                            <multiselect
                                v-model="item.type"
                                :options="listAchievements"
                                :selectedLabel="$t('selected')"
                                :placeholder="$t('type_soc_link')"
                                value="uid"
                                v-validate="'required'"
                                :loading="listLoading"
                                :custom-label="nameLinks"
                                :name="`i_aa_${ item.uid }`"
                                track-by="uid">
                                    <div slot="noOptions">
                                        {{$t('no_data_text')}}
                                    </div>
                            </multiselect>
                            <span class="text-danger w-full text-sm" v-show="errors.has(`i_aa_${ item.key }`)">{{ $t('validation_required') }}</span>
                        </div>
                        <div class="mt-2 lg:mt-0 w-full lg:pl-2">
                            <vs-input
                                v-validate="'required'"
                                :placeholder="$t('place_link')"
                                class="w-full mb-0"
                                :name="`i_a_${ item.key }`"
                                v-model="item.content" />
                            <span class="text-danger w-full text-sm" v-show="errors.has(`i_a_${ item.key }`)">{{ $t('validation_required') }}</span>
                        </div>
                    </div>
                    <!-- Кнопка удаления достижения -->
                    <vs-button
                        v-if="links.length > 1"
                        color="red"
                        class="ml-2"
                        @click="deleteItem(item)"
                        type="border"
                        icon-pack="feather"
                        icon="icon-trash">
                    </vs-button>
                </div>
            </div>
            <div class="mb_reverse lg:flex mt-4">
                <!-- Кнопка сохранить -->
                <vs-button class="edit_achievement_btn edt_btn lg:mr-3" color="primary" @click="formSubmit()" icon-pack="feather" icon="icon-save" type="filled">{{$t('save')}}</vs-button>

                <!-- Кнопка добавить достижение -->
                <vs-button @click="add()" class="edit_btn edt_btn" color="primary" type="border" icon-pack="feather" icon="icon-plus">{{$t('add')}}</vs-button>
            </div>
        </div>
    </vx-card>
</template>

<script>
export default {
    props: {
        userData: Object
    },
    data() {
        return {
            listDeleted: [],
            links: [],
            sLinks_isUpload:0,
            generateLinks:[],
            listAchievements: [],
            listLoading: false,
        }
    },
    created: function() {
        this.generate()
        this.getAchievementsLists()
    },
    computed: {
        user() {
            return this.$store.state.user.user
        }
    },
    watch: {
        async sLinks_isUpload(val){
            //если все запросы на common/social_links отработают
            //то updateSocialLinks загрузить массив соц сетей 
            if(val !=0 && val == this.links.length){
                await this.updateSocialLinks();
            }
        },
    },
    methods: {
        nameLinks(data){ 
            return data.name
        },

        async getAchievementsLists() {
            // Получаем списко типов достижений
            try {
                this.listLoading = true
                this.listAchievements = (await this.$http("common/social_web_types/")).data;
            } catch(e) {
                this.$vs.notify({
                    text: this.$t('error'),
                    color: 'danger'
                })
            } finally {
                this.listLoading = false
            }
        },

        generate() {
            // Генерируем форму из полученных данных о пользователе
            if(this.userData.social_links.length) {
                this.userData.social_links.forEach((item, index) => {
                    this.links.push({
                        content: item.social_link,
                        key: index,
                        uid: item.uid,
                        level: null,
                        type:{name:item.social_web_type.name,uid: item.social_web_type.uid }
                    })
                })
            } else {
                this.links = [
                    {
                        content: '',
                        level: null,
                        type: null,
                        uid: null,
                        key: Date.now()
                    }
                ]
            }
        },

        add() {
            // Добавляем новое достижение
            this.links.push({
                content: '',
                level: null,
                type: null,
                uid:null,
                key: Date.now()
            })
        },

        deleteItem(elem) {
            // Удаляем достижение
            const index = this.links.findIndex(item => item.key === elem.key)
            this.links.splice(index, 1)

            if(elem.uid)
                this.listDeleted.push(elem.uid)

            if(!this.links.length)
                this.add()
        },

        async formSubmit() {
            // Сохраняем/обновляем достижения
            this.$validator.validateAll().then(async result => {
                this.listLoading = true

                if(result) {
                    try {
                        //генерация массива для lisks
                        await this.GenerateBeforeUid();

                    } catch(e) {
                        this.$vs.notify({text: this.$t('error'), color: 'danger'})//notify
                    } finally {
                        this.$vs.notify({ text: this.$t('data_saved'), color: 'success'})//notify
                    }
                }

                this.listLoading = false

            })
        },

        async GenerateBeforeUid(){
            let uids = [];
                // из формы взять заполненые соц сети
            await this.links.forEach(async (item) => {
                if (this.getValidUrl(item.content)) {
                    //добавить базу и взять uid и  их применить как social_links
                    const response = await this.$http.post(
                        "/common/social_links/",
                        {
                            social_web_type: item.type.uid,
                            social_link: this.getValidUrl(item.content),
                        }
                    )
                    if (response.data) {
                        uids.push(response.data.uid);
                        // это счетчик для определение выполненных загузок
                        // для него есть watcher
                        this.sLinks_isUpload = this.sLinks_isUpload+1;
                    }
                } else {
                    return false;
                }
            });

            this.generateLinks = uids;

        },

        async updateSocialLinks(){
                if(this.generateLinks.length){
                    await this.$http.put( `/user/profile/${this.userData.profileId}/social_links/edit/`,
                                                        { 
                                                            social_links: this.generateLinks 
                                                        }
                                        );
                }
        },

        getValidUrl(url = "") {
            let RegExp = /^((ftp|http|https):\/\/)?(www\.)?([A-Za-zА-Яа-я0-9]{1}[A-Za-zА-Яа-я0-9\-]*\.?)*\.{1}[A-Za-zА-Яа-я0-9-]{2,8}(\/([\w#!:.?+=&%@!\-\/])*)?/;

            if (RegExp.test(url)) {
                let newUrl = window.decodeURIComponent(url);
                newUrl = newUrl.trim().replace(/\s/g, "");
                if (/^(:\/\/)/.test(newUrl)) {
                    return `http${ newUrl }`;
                }
                if (!/^(f|ht)tps?:\/\//i.test(newUrl)) {
                    return `http://${ newUrl }`;
                }
                return newUrl;
            } else {
                this.$vs.notify({
                    title: this.$t("error"),
                    text: this.$t("invalid_link"),
                    color: "danger",
                });
            }
        },
    }
}
</script>

<style lang="scss">
.edit_achievement_btn{
    position: relative;
    .con-vs-loading{
        position: absolute;
    }
}
</style>
